// El locale de la página que se está editando. puck-config es un objeto estático
// cuyos render de campo no reciben contexto de página, así que el editor lo fija
// aquí (setEditorLocale) y los campos con IA lo leen (getEditorLocale) para generar
// copy en el idioma correcto (las páginas son una fila por locale, no nested-bilingüe).
let current = 'es';

export const setEditorLocale = (locale: string) => { current = locale || 'es'; };
export const getEditorLocale = () => current;
